<div
    class="splash"
    [ngClass]="[
        mobileBackgroundClass(),
        block.data.backgroundImageRightStacked ? 'splash--right-stacked' : '',
        hasMobileOverlay ? 'splash--mobile-overlay' : '',
    ]"
    [ngStyle]="getSplashBackground()">
    <div class="container">
        <div
            [ngClass]="{
                'splash-cta--no-buttons': isNoButtons,
                'splash-cta--transparent': !!block.data?.transparentBackground,
                'splash-cta--no-padding': !!block.data?.removePadding,
                'splash-cta--no-border-radius': !!block.data?.removeBorderRadius,
            }"
            class="splash-cta"
            [ngStyle]="getContainerStyle()">
            @if (block.data.heading) {
                <h1 [innerHtml]="block.data.heading" class="splash-cta__heading" [ngStyle]="getHeadingStyle()"></h1>
            }
            @if (block.data.text) {
                <div [innerHtml]="block.data.text" class="splash-cta__text" [ngStyle]="getTextStyle()"></div>
            }
            <div class="splash-cta__buttons" [class.splash-cta__buttons--no-flex]="!!block.data?.buttonNoFlex">
                <!-- New: Render from contentItems (safe accessor) when available -->
                @if (contentItems.length > 0) {
                    @for (item of contentItems; track $index) {
                        <!-- Button 1: SSO or Standard based on item.data.isSsoLink -->
                        @if (!!item?.data?.isSsoLink && item?.data?.linkText && item?.data?.ssoLink) {
                            <ng-container
                                *ngTemplateOutlet="
                                    ctaButtonSso;
                                    context: {
                                        text: item.data.linkText,
                                        sso: item.data.ssoLink,
                                        aria: item.data.linkAriaLabel,
                                        desc: item.data.linkDescription,
                                        iconUrl: item.data.buttonIcon_url,
                                        icon: item.data.buttonIcon,
                                    }
                                "></ng-container>
                        } @else if (!!item?.data?.linkText && !!item?.data?.link) {
                            <ng-container
                                *ngTemplateOutlet="
                                    ctaButton;
                                    context: {
                                        text: item.data.linkText,
                                        link: item.data.link,
                                        external: item.data.externalLink,
                                        aria: item.data.linkAriaLabel,
                                        desc: item.data.linkDescription,
                                        iconUrl: item.data.buttonIcon_url,
                                        icon: item.data.buttonIcon,
                                    }
                                "></ng-container>
                        }

                        <!-- Button 2 (optional within the same item) -->
                        @if (!!item?.data?.isTwoButtons) {
                            @if (!!item?.data?.isSsoLink2 && item?.data?.linkText2 && item?.data?.ssoLink2) {
                                <ng-container
                                    *ngTemplateOutlet="
                                        ctaButtonSso;
                                        context: {
                                            text: item.data.linkText2,
                                            sso: item.data.ssoLink2,
                                            aria: item.data.linkAriaLabel2,
                                            desc: item.data.linkDescription2,
                                            iconUrl: item.data.buttonIcon2_url,
                                            icon: item.data.buttonIcon2,
                                        }
                                    "></ng-container>
                            } @else if (!!item?.data?.linkText2 && !!item?.data?.link2) {
                                <ng-container
                                    *ngTemplateOutlet="
                                        ctaButton;
                                        context: {
                                            text: item.data.linkText2,
                                            link: item.data.link2,
                                            external: item.data.externalLink2,
                                            aria: item.data.linkAriaLabel2,
                                            desc: item.data.linkDescription2,
                                            iconUrl: item.data.buttonIcon2_url,
                                            icon: item.data.buttonIcon2,
                                        }
                                    "></ng-container>
                            }
                        }
                    }
                } @else {
                    <!-- Legacy: Render from root-level fields for backward compatibility -->
                    <!-- Standard link -->
                    @if (showStdLink) {
                        <ng-container
                            *ngTemplateOutlet="
                                ctaButton;
                                context: {
                                    text: block.data.linkText,
                                    link: block.data.link,
                                    external: block.data.externalLink,
                                    aria: block.data.linkAriaLabel,
                                    desc: block.data.linkDescription,
                                    iconUrl: block.data.buttonIcon_url,
                                    icon: block.data.buttonIcon,
                                }
                            "></ng-container>
                    }
                    <!-- SSO link -->
                    @if (showSsoLink) {
                        <ng-container
                            *ngTemplateOutlet="
                                ctaButtonSso;
                                context: {
                                    text: block.data.linkText,
                                    sso: block.data.ssoLink,
                                    aria: block.data.linkAriaLabel,
                                    desc: block.data.linkDescription,
                                    iconUrl: block.data.buttonIcon_url,
                                    icon: block.data.buttonIcon,
                                }
                            "></ng-container>
                    }
                    <!-- Optional second links -->
                    @if (showStdLink2) {
                        <ng-container
                            *ngTemplateOutlet="
                                ctaButton;
                                context: {
                                    text: block.data.linkText2,
                                    link: block.data.link2,
                                    external: block.data.externalLink2,
                                    aria: block.data.linkAriaLabel2,
                                    desc: block.data.linkDescription2,
                                    iconUrl: block.data.buttonIcon2_url,
                                    icon: block.data.buttonIcon2,
                                }
                            "></ng-container>
                    }
                    @if (showSsoLink2) {
                        <ng-container
                            *ngTemplateOutlet="
                                ctaButtonSso;
                                context: {
                                    text: block.data.linkText2,
                                    sso: block.data.ssoLink2,
                                    aria: block.data.linkAriaLabel2,
                                    desc: block.data.linkDescription2,
                                    iconUrl: block.data.buttonIcon2_url,
                                    icon: block.data.buttonIcon2,
                                }
                            "></ng-container>
                    }
                }
            </div>
            @if (block.data.subText) {
                <hr class="splash-cta__hr" [ngStyle]="getHrStyle()" />
                <div [innerHtml]="block.data.subText" class="splash-cta__sub-text" [ngStyle]="getSubTextStyle()"></div>
            }
        </div>
    </div>
    @if (block.data.backgroundImageRightStacked) {
        <div class="splash__right-stacked-bg" [ngStyle]="getRightStackedBackgroundStyle()"></div>
    }
</div>

<!-- Reusable CTA button template -->
<ng-template
    #ctaButton
    let-text="text"
    let-link="link"
    let-external="external"
    let-aria="aria"
    let-desc="desc"
    let-iconUrl="iconUrl"
    let-icon="icon">
    @if (!external) {
        <!-- Not external so we're safe to use routerLink -->
        @if (desc) {
            <a
                [routerLink]="link"
                [target]="external ? '_blank' : '_self'"
                [attr.aria-label]="aria ? aria : ''"
                class="btn btn-primary mb-0 splash-cta__btn splash-cta__btn--has-desc">
                <span class="splash-cta__btn-content">
                    <span class="splash-cta__btn-text">{{ text }}</span>
                    <span class="splash-cta__btn-desc">{{ desc }}</span>
                </span>
                @if (iconUrl || icon) {
                    <span class="splash-cta__btn-icon">
                        <img [src]="iconUrl || icon" alt="" />
                    </span>
                }
            </a>
        } @else {
            <a
                [routerLink]="link"
                [target]="external ? '_blank' : '_self'"
                [attr.aria-label]="aria ? aria : ''"
                class="btn btn-primary mb-0 splash-cta__btn">
                <span class="splash-cta__btn-content">
                    <span class="splash-cta__btn-text">{{ text }}</span>
                </span>
                @if (iconUrl || icon) {
                    <span class="splash-cta__btn-icon splash-cta__btn-icon-no-desc">
                        <img [src]="iconUrl || icon" alt="" />
                    </span>
                }
            </a>
        }
    } @else {
        <!-- External so we're using href -->
        @if (desc) {
            <a
                [href]="link"
                [target]="external ? '_blank' : '_self'"
                [attr.aria-label]="aria ? aria : ''"
                class="btn btn-primary mb-0 splash-cta__btn splash-cta__btn--has-desc">
                <span class="splash-cta__btn-content">
                    <span class="splash-cta__btn-text">{{ text }}</span>
                    <span class="splash-cta__btn-desc">{{ desc }}</span>
                </span>
                @if (iconUrl || icon) {
                    <span class="splash-cta__btn-icon">
                        <img [src]="iconUrl || icon" alt="" />
                    </span>
                }
            </a>
        } @else {
            <a
                [href]="link"
                [target]="external ? '_blank' : '_self'"
                [attr.aria-label]="aria ? aria : ''"
                class="btn btn-primary mb-0 splash-cta__btn">
                <span class="splash-cta__btn-content">
                    <span class="splash-cta__btn-text">{{ text }}</span>
                </span>
                @if (iconUrl || icon) {
                    <span class="splash-cta__btn-icon splash-cta__btn-icon-no-desc">
                        <img [src]="iconUrl || icon" alt="" />
                    </span>
                }
            </a>
        }
    }
</ng-template>

<ng-template
    #ctaButtonSso
    let-text="text"
    let-sso="sso"
    let-aria="aria"
    let-desc="desc"
    let-iconUrl="iconUrl"
    let-icon="icon">
    @if (desc) {
        <a
            href="javascript:void(0);"
            (click)="initiateSSO(sso)"
            [attr.aria-label]="aria ? aria : ''"
            class="btn btn-primary mb-0 splash-cta__btn splash-cta__btn--has-desc">
            <span class="splash-cta__btn-content">
                <span class="splash-cta__btn-text">{{ text }}</span>
                <span class="splash-cta__btn-desc">{{ desc }}</span>
            </span>
            @if (iconUrl || icon) {
                <span class="splash-cta__btn-icon">
                    <img [src]="iconUrl || icon" alt="" />
                </span>
            }
        </a>
    } @else {
        <a
            href="javascript:void(0);"
            (click)="initiateSSO(sso)"
            [attr.aria-label]="aria ? aria : ''"
            class="btn btn-primary mb-0 splash-cta__btn"
            [innerText]="text"></a>
    }
</ng-template>

<!--TODO: Add Wistia video as background option -->
